import PropTypes from "prop-types"


const properties = {
  accountId: PropTypes.string.isRequired,
  audiences: PropTypes.arrayOf(PropTypes.string),
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string,
  email: PropTypes.string.isRequired,
  expiresAt: PropTypes.string.isRequired,
  failedAttemptCount: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  lastUsedAt: PropTypes.string,
  lastUsedIp: PropTypes.string,
  name: PropTypes.string.isRequired,
  revokedAt: PropTypes.string,
  status: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
  updatedBy: PropTypes.string,
  usageCount: PropTypes.number.isRequired
}

const RevokeMyPersonalAccessTokenOutputShapeShape = PropTypes.exact(properties)

export default RevokeMyPersonalAccessTokenOutputShapeShape
export { properties }
